import React from 'react';
import * as linkify from 'linkifyjs';
import { Link } from '@mui/material';

/**
 * Add <Link> or <a href> elements to any part of a text string which is identified as being a URL
 * @param text A text string to add link elements to
 * @returns a React string which can be wrapped with typography or elements as needed
 */
export const linkifyText = (text: string): React.ReactNode => {
	const textLinks = linkify.find(text);

	const textParts: React.ReactNode[] = [];

	if (textLinks.length > 0) {
		textLinks.forEach((link, i) => {
			if (i === 0) {
				textParts.push(text.substring(0, link.start));
			} else {
				textParts.push(text.substring(textLinks[i - 1].end, link.start));
			}

			textParts.push(
				<Link aria-label={`Link to ${link.type}`} key={`${link.type}-to-${link.value}`} href={link.href} target="_blank" rel="noreferrer">
					{link.value}
				</Link>
			);

			if (i + 1 >= textLinks.length && link.end < text.length) {
				textParts.push(text.substring(link.end));
			}
		});
	} else {
		textParts.push(text);
	}

	return <>{textParts.map((part) => part)}</>;
};
